import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import GuestLayout from "@/layouts/GuestLayout";
import { redirectIfAuthenticated } from "@/routing/guards";
import { rootRoute } from "./__root";
import { loginSearchSchema, setPasswordSearchSchema } from "@/routing/search";

const Login = lazyRouteComponent(() => import("@/pages/guest/Login/Page"));
const ForgotPassword = lazyRouteComponent(() => import("@/pages/guest/ForgotPassword/Page"));
const SetPassword = lazyRouteComponent(() => import("@/pages/guest/SetPassword/Page"));

const guestLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "guest",
  beforeLoad: redirectIfAuthenticated,
  component: GuestLayout,
});

export const loginRoute = createRoute({
  getParentRoute: () => guestLayoutRoute,
  path: "/login",
  validateSearch: loginSearchSchema,
  component: Login,
});

export const forgotPasswordRoute = createRoute({
  getParentRoute: () => guestLayoutRoute,
  path: "/forgotpassword",
  component: ForgotPassword,
});

export const setPasswordRoute = createRoute({
  getParentRoute: () => guestLayoutRoute,
  path: "/setpassword",
  validateSearch: setPasswordSearchSchema,
  component: SetPassword,
});

export const guestRoutes = [
  guestLayoutRoute.addChildren([
    loginRoute,
    forgotPasswordRoute,
    setPasswordRoute,
  ]),
];
